import { FC, Fragment, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PackageOfflineResponse } from 'ts/package/interfaces/PackageOfflineResponse';
import ExpiredToken from 'components/shared/ExpiredToken';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import OrderBook from './OrderBook';
import BookSummary from './BookSummary';
import PackageBookSkeleton from '../Book/PackageBookSkeleton';
import { getBookOfflinePackage } from 'services/package';
import { saveScreenshot } from 'utils/utils';

const PackageOfflineBookPage: FC = () => {
  const [response, setResponse] = useState<PackageOfflineResponse>();
  const [couponAmount, setCouponAmount] = useState('');
  const [urlParams] = useSearchParams();
  const bookRef = useRef<HTMLDivElement>(null);
  useGetPage('ILPackage/Book');

  useEffect(() => {
    (async () => {
      const params = Object.fromEntries(urlParams.entries());
      const newResponse = await getBookOfflinePackage(params as any);
      if (newResponse) {
        const data = {
          ...newResponse,
          dealModel: {
            ...newResponse.dealModel,
            paxes: newResponse.dealModel.paxes.map((pax) => ({ ...pax, gender: 'M' })),
          },
        };
        setResponse(data);
      }
    })();
  }, []); // eslint-disable-line

  return (
      <div className="details-wrapper">
        {!!response?.dealModel && !response?.sessionExpired && (
          <Fragment>
            <OrderBook
              dealModel={response.dealModel}
              onClickBook={async () =>
                await saveScreenshot(bookRef.current, 'Book', 'OfflinePackages')
              }
              couponAmount={couponAmount}
            />
            <BookSummary
              deal={response.dealModel}
              couponAmount={couponAmount}
              setCouponAmount={setCouponAmount}
            />
          </Fragment>
        )}

        {response?.sessionExpired && <ExpiredToken storePath="ilpackage" />}

        {!response && <PackageBookSkeleton />}
      </div>
  );
};

export default withErrorBoundary(PackageOfflineBookPage, 'PackageOfflineBookPage');
